import React from 'react';
export const ApprovedId = () => (
  <svg width="139px" height="114px" viewBox="0 0 139 114" version="1.1">
    <defs>
      <path
        d="M12.883,0.739 L5.847,8.782 L2.239,5.39 C1.719,4.901 0.901,4.927 0.411,5.447 C-0.077,5.967 -0.053,6.785 0.468,7.275 L5.052,11.586 C5.586,12.087 6.429,12.047 6.911,11.495 L14.829,2.442 C15.299,1.904 15.244,1.087 14.707,0.617 C14.462,0.402 14.159,0.297 13.857,0.297 C13.497,0.297 13.138,0.447 12.883,0.739 Z"
        id="path-1"
      />
      <path
        d="M12.883,0.739 L5.847,8.782 L2.239,5.39 C1.719,4.901 0.901,4.927 0.411,5.447 C-0.077,5.967 -0.053,6.785 0.468,7.275 L5.052,11.586 C5.586,12.087 6.429,12.047 6.911,11.495 L14.829,2.442 C15.299,1.904 15.244,1.087 14.707,0.617 C14.462,0.402 14.159,0.297 13.857,0.297 C13.497,0.297 13.138,0.446 12.883,0.739 Z"
        id="path-3"
      />
      <path
        d="M12.883,0.739 L5.847,8.782 L2.239,5.39 C1.719,4.901 0.901,4.927 0.411,5.447 C-0.077,5.967 -0.053,6.785 0.468,7.275 L5.052,11.586 C5.586,12.087 6.429,12.047 6.911,11.495 L14.829,2.442 C15.299,1.904 15.244,1.087 14.707,0.617 C14.462,0.402 14.159,0.297 13.857,0.297 C13.497,0.297 13.138,0.447 12.883,0.739 Z"
        id="path-5"
      />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-1055.000000, -1884.000000)">
        <g transform="translate(1056.000000, 1884.000000)">
          <path
            d="M84.0538,10.9906 L79.8668,10.9336"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M89.6993,4.7904 L89.7563,0.6034"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M85.6295,6.2865 L82.6485,3.1445"
            stroke="#F5C400"
            strokeLinecap="round"
          />
          <path
            d="M37.1133,109.5395 L18.3573,109.5395"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.3575,109.5395 L0.3215,109.5395"
            stroke="#EB1D26"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M81.772,109.2758 C81.772,111.3608 74.408,113.0498 65.323,113.0498 C56.239,113.0498 48.874,111.3608 48.874,109.2758 C48.874,107.1908 56.239,105.5008 65.323,105.5008 C74.408,105.5008 81.772,107.1908 81.772,109.2758"
            fill="#D0D7DA"
          />
          <path
            d="M80.2466,66.9203 L29.4386,73.8013 C27.3026,74.0903 25.3366,72.5943 25.0476,70.4583 L20.9496,40.1993 C20.6606,38.0643 22.1576,36.0983 24.2926,35.8093 L75.1006,28.9283 C77.2366,28.6393 79.2026,30.1353 79.4916,32.2713 L83.5896,62.5293 C83.8786,64.6653 82.3826,66.6313 80.2466,66.9203"
            fill="#FFFFFF"
          />
          <g transform="translate(20.000000, 33.710000)">
            <path
              d="M17.2515,0.3529 L2.8655,2.3019 C1.5185,2.4839 0.5735,3.7239 0.7565,5.0719 L5.2405,38.1849 C5.4235,39.5329 6.6635,40.4759 8.0105,40.2939 L19.1405,38.7869 L24.4525,38.0669 L61.6745,33.0259 C63.0215,32.8429 63.9655,31.6039 63.7835,30.2559 L63.4335,27.6709"
              fill="#FFFFFF"
            />
            <path
              d="M17.2515,0.3529 L2.8655,2.3019 C1.5185,2.4839 0.5735,3.7239 0.7565,5.0719 L5.2405,38.1849 C5.4235,39.5329 6.6635,40.4759 8.0105,40.2939 L19.1405,38.7869 L24.4525,38.0669 L61.6745,33.0259 C63.0215,32.8429 63.9655,31.6039 63.7835,30.2559 L63.4335,27.6709"
              stroke="#C3D3D8"
              strokeWidth="1.001"
              strokeLinecap="round"
            />
          </g>
          <g transform="translate(21.000000, 33.710000)">
            <polyline
              fill="#F3F4F6"
              points="8.5567 13.598 1.0487 14.616 0.2517 8.73 58.7937 0.801 59.5907 6.687 11.7267 13.169"
            />
            <polyline
              stroke="#DDE3E2"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
              points="8.5567 13.598 1.0487 14.616 0.2517 8.73 58.7937 0.801 59.5907 6.687 11.7267 13.169"
            />
          </g>
          <g transform="translate(40.000000, 47.710000)">
            <path d="M0.128,3.9105 L22.849,0.8335" fill="#DDE3E2" />
            <path
              d="M0.128,3.9105 L22.849,0.8335"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(26.000000, 51.710000)">
            <path d="M0.0567,1.8168 L11.3607,0.2858" fill="#DDE3E2" />
            <path
              d="M0.0567,1.8168 L11.3607,0.2858"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(40.000000, 50.710000)">
            <path d="M0.0787,3.7064 L23.2387,0.5694" fill="#DDE3E2" />
            <path
              d="M0.0787,3.7064 L23.2387,0.5694"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <g transform="translate(26.000000, 54.710000)">
            <path d="M0.4459,1.5521 L11.3529,0.0751" fill="#DDE3E2" />
            <path
              d="M0.4459,1.5521 L11.3529,0.0751"
              stroke="#DDE5E8"
              strokeWidth="1.001"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <path
            d="M91.7842,61.1215 L43.1142,61.1215 C40.2402,61.1215 37.9102,58.7925 37.9102,55.9185 L37.9102,27.9855 C37.9102,25.1115 40.2402,22.7825 43.1142,22.7825 L91.7842,22.7825 C94.6582,22.7825 96.9872,25.1115 96.9872,27.9855 L96.9872,55.9185 C96.9872,58.7925 94.6582,61.1215 91.7842,61.1215"
            fill="#F3F4F6"
          />
          <path
            d="M95.5464,57.8256 L44.2754,57.8256 C42.1194,57.8256 40.3724,56.0786 40.3724,53.9236 L40.3724,23.3886 C40.3724,21.2336 42.1194,19.4866 44.2754,19.4866 L95.5464,19.4866 C97.7014,19.4866 99.4484,21.2336 99.4484,23.3886 L99.4484,53.9236 C99.4484,56.0786 97.7014,57.8256 95.5464,57.8256"
            fill="#FFFFFF"
          />
          <path
            d="M99.4488,42.2426 L99.4488,47.6966 L99.4488,55.3636 C99.4488,56.7226 98.3468,57.8256 96.9878,57.8256 L42.8338,57.8256 C41.4738,57.8256 40.3718,56.7226 40.3718,55.3636 L40.3718,21.9476 C40.3718,20.5886 41.4738,19.4866 42.8338,19.4866 L77.3818,19.4866 L82.5728,19.4866"
            stroke="#391572"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M47.2134,44.0404 L55.4184,44.0404"
            stroke="#D71385"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M59.5211,44.0404 L67.7261,44.0404"
            stroke="#D71385"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M71.8287,44.0404 L80.0337,44.0404"
            stroke="#D71385"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M84.1363,44.0404 L92.3413,44.0404"
            stroke="#D71385"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M47.2134,48.9633 L54.1874,48.9633"
            stroke="#C3D3D8"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M55.024,39.5199 L48.018,39.5199 C47.574,39.5199 47.213,39.1599 47.213,38.7149 L47.213,31.7089 C47.213,31.2649 47.574,30.9049 48.018,30.9049 L55.024,30.9049 C55.468,30.9049 55.829,31.2649 55.829,31.7089 L55.829,38.7149 C55.829,39.1599 55.468,39.5199 55.024,39.5199"
            fill="#FEFCDD"
          />
          <path
            d="M55.024,39.5199 L48.018,39.5199 C47.574,39.5199 47.213,39.1599 47.213,38.7149 L47.213,31.7089 C47.213,31.2649 47.574,30.9049 48.018,30.9049 L55.024,30.9049 C55.468,30.9049 55.829,31.2649 55.829,31.7089 L55.829,38.7149 C55.829,39.1599 55.468,39.5199 55.024,39.5199 Z"
            stroke="#F5C400"
            strokeWidth="0.751"
            strokeLinecap="round"
          />
          <path
            d="M47.2134,35.2123 L55.8284,35.2123"
            stroke="#F5C400"
            strokeWidth="0.751"
            strokeLinecap="round"
          />
          <polygon
            fill="#FFFFFF"
            points="50.5928 37.3754 49.5118 36.2954 49.5118 34.1304 50.5928 33.0504 52.4488 33.0504 53.5308 34.1304 53.5308 36.2954 52.4488 37.3754"
          />
          <path
            d="M52.605,32.6733 L50.437,32.6733 C49.929,33.1823 49.645,33.4663 49.136,33.9753 L49.136,36.4493 C49.645,36.9573 49.929,37.2423 50.437,37.7503 L52.605,37.7503 C53.113,37.2423 53.397,36.9573 53.906,36.4493 L53.906,33.9753 C53.397,33.4663 53.113,33.1823 52.605,32.6733 M52.293,33.4243 L52.432,33.5633 L53.155,34.2853 L53.155,36.1393 L52.931,36.3623 L52.294,36.9993 L50.749,36.9993 L49.888,36.1393 L49.888,34.2853 L49.979,34.1943 L50.749,33.4243 L52.293,33.4243"
            fill="#F5C400"
          />
          <path
            d="M137.5244,109.7367 L92.7344,109.7367"
            stroke="#EB1D26"
            strokeWidth="1.001"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <polyline
            stroke="#DDE5E8"
            strokeLinecap="round"
            strokeLinejoin="round"
            points="88.8121 54.5795 96.5151 54.5795 96.5151 50.5715"
          />
          <path
            d="M83.3829,54.5795 L86.2399,54.5795"
            stroke="#DDE5E8"
            strokeLinecap="round"
          />
          <path
            d="M91.9322,13.3158 C91.4652,13.6688 91.0152,14.0548 90.5902,14.4808 C90.1642,14.9068 89.7782,15.3558 89.4252,15.8228 C85.6612,20.8078 86.0472,27.9298 90.5902,32.4728 C95.1332,37.0168 102.2552,37.4028 107.2412,33.6378 C107.7072,33.2858 108.1572,32.8988 108.5832,32.4728 C109.0082,32.0478 109.3942,31.5978 109.7472,31.1308 C113.5122,26.1458 113.1262,19.0238 108.5832,14.4808 C104.0402,9.9378 96.9172,9.5508 91.9322,13.3158"
            fill="#CBD62A"
          />
          <path
            d="M91.9322,13.3158 C91.4652,13.6688 91.0152,14.0548 90.5902,14.4808 C90.1642,14.9068 89.7782,15.3558 89.4252,15.8228 C85.6612,20.8078 86.0472,27.9298 90.5902,32.4728 C95.1332,37.0168 102.2552,37.4028 107.2412,33.6378 C107.7072,33.2858 108.1572,32.8988 108.5832,32.4728 C109.0082,32.0478 109.3942,31.5978 109.7472,31.1308 C113.5122,26.1458 113.1262,19.0238 108.5832,14.4808 C104.0402,9.9378 96.9172,9.5508 91.9322,13.3158 Z"
            stroke="#575825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M91.9322,13.3158 C91.4652,13.6688 91.0152,14.0548 90.5902,14.4808 C90.1642,14.9068 89.7782,15.3558 89.4252,15.8228 C85.6612,20.8078 86.0472,27.9298 90.5902,32.4728 C95.1332,37.0168 102.2552,37.4028 107.2412,33.6378 C107.7072,33.2858 108.1572,32.8988 108.5832,32.4728 C109.0082,32.0478 109.3942,31.5978 109.7472,31.1308 C113.5122,26.1458 113.1262,19.0238 108.5832,14.4808 C104.0402,9.9378 96.9172,9.5508 91.9322,13.3158"
            fill="#CBD62A"
          />
          <path
            d="M91.9322,13.3158 C91.4652,13.6688 91.0152,14.0548 90.5902,14.4808 C90.1642,14.9068 89.7782,15.3558 89.4252,15.8228 C85.6612,20.8078 86.0472,27.9298 90.5902,32.4728 C95.1332,37.0168 102.2552,37.4028 107.2412,33.6378 C107.7072,33.2858 108.1572,32.8988 108.5832,32.4728 C109.0082,32.0478 109.3942,31.5978 109.7472,31.1308 C113.5122,26.1458 113.1262,19.0238 108.5832,14.4808 C104.0402,9.9378 96.9172,9.5508 91.9322,13.3158 Z"
            stroke="#575825"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M97.8467,26.4926 L104.8827,18.4486 C105.3527,17.9116 106.1697,17.8566 106.7067,18.3266 C107.2447,18.7976 107.2997,19.6146 106.8287,20.1516 L98.9107,29.2046 C98.4287,29.7566 97.5857,29.7976 97.0517,29.2956 L92.4677,24.9846 C91.9477,24.4956 91.9227,23.6776 92.4117,23.1566 C92.9007,22.6366 93.7197,22.6106 94.2397,23.0996 L97.8467,26.4926 Z"
            fill="#FFFFFF"
          />
          <g transform="translate(92.000000, 17.710000)">
            <mask id="mask-2" fill="white">
              <use xlinkHref="#path-1" />
            </mask>
            <g />
            <polygon
              fill="#FFFFFF"
              mask="url(#mask-2)"
              points="-159.017 72.291 377.274 72.291 377.274 -215.255 -159.017 -215.255"
            />
          </g>
          <g transform="translate(92.000000, 17.710000)">
            <mask id="mask-4" fill="white">
              <use xlinkHref="#path-3" />
            </mask>
            <g />
            <polygon
              fill="#FFFFFF"
              mask="url(#mask-4)"
              points="-1.018 13.015 16.226 13.015 16.226 -0.781 -1.018 -0.781"
            />
            <polygon
              stroke="#575825"
              mask="url(#mask-4)"
              points="-1.018 13.015 16.226 13.015 16.226 -0.781 -1.018 -0.781"
            />
          </g>
          <g transform="translate(92.000000, 17.710000)">
            <mask id="mask-6" fill="white">
              <use xlinkHref="#path-5" />
            </mask>
            <g />
            <polygon
              stroke="#575825"
              mask="url(#mask-6)"
              points="-159.017 72.291 377.274 72.291 377.274 -215.255 -159.017 -215.255"
            />
          </g>
          <path
            d="M97.8467,26.4926 L104.8827,18.4486 C105.3527,17.9116 106.1697,17.8566 106.7067,18.3266 C107.2447,18.7976 107.2997,19.6146 106.8287,20.1516 L98.9107,29.2046 C98.4287,29.7566 97.5857,29.7976 97.0517,29.2956 L92.4677,24.9846 C91.9477,24.4956 91.9227,23.6776 92.4117,23.1566 C92.9007,22.6366 93.7197,22.6106 94.2397,23.0996 L97.8467,26.4926 Z"
            stroke="#575825"
          />
          <path
            d="M26.8238,9.3481 L26.8238,11.2991"
            stroke="#CCD82B"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M26.8238,15.2026 L26.8238,17.1536"
            stroke="#CCD82B"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M30.7261,13.2514 L28.7751,13.2514"
            stroke="#CCD82B"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M24.8726,13.2514 L22.9216,13.2514"
            stroke="#CCD82B"
            strokeWidth="1.001"
            strokeLinecap="round"
          />
          <path
            d="M38.0123,5.019 C38.0123,5.837 37.3493,6.5 36.5313,6.5 C35.7133,6.5 35.0513,5.837 35.0513,5.019 C35.0513,4.202 35.7133,3.539 36.5313,3.539 C37.3493,3.539 38.0123,4.202 38.0123,5.019"
            fill="#D62793"
          />
          <path
            d="M116.4644,46.5629 C116.4644,47.3799 115.8014,48.0429 114.9834,48.0429 C114.1654,48.0429 113.5024,47.3799 113.5024,46.5629 C113.5024,45.7449 114.1654,45.0819 114.9834,45.0819 C115.8014,45.0819 116.4644,45.7449 116.4644,46.5629"
            fill="#F5C400"
          />
        </g>
      </g>
    </g>
  </svg>
);
